import styled from '@emotion/styled'

import { ButtonBase } from '@mui/material'
import { colors, fontSize, size } from '@styles/theme'
import { useLongPress } from 'use-long-press'

const GridContainer = styled(ButtonBase)`
  position: relative;
  aspect-ratio: 1;  
  border-radius: 12px;
`

const GridImage = styled.img`
  height: 100%;
  width: 100%;
  aspect-ratio: 1;
  border-radius: 12px;
  object-fit: cover;
`

const SelectedOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  height: 100%;
  width: 100%;
  border: 3px solid ${colors.statusColors['right_now']('light')};
  border-radius: 12px;
  box-shadow: inset 1px 1px 4px 0.05px #FFFFFFB3,
              inset -1px -1px 4px 1px #000000;
`

const OverlayNumber = styled.div`
  position: absolute;
  right: ${size(0.5)};
  top: ${size(0.5)};

  display: flex;
  align-items: center;
  justify-content: center;

  height: ${size(2.75)};
  width: ${size(2.75)};
  border-radius: 100px;

  background-color: ${colors.statusColors['right_now']('light')};
  text-shadow: 0 1px 4px #333333CC;
  box-shadow: 0 1px 4px 2px #333333CC;
  font-weight: 600;
  font-size: ${fontSize('sm')};
`

const MediaGridItem = ({ image, selectedState, removeSelected, addSelected, disabled, openViewer }) => {
  const isSelected = image.uuid in selectedState.index
  const selectedIndex = selectedState?.index?.[image.uuid]
  const bindLongPress = useLongPress(handleLongPress)

  function handleLongPress() {
    const state = { isSelected, selectedIndex, image }
    openViewer(null, { state })
  }

  return (
    <GridContainer
      {...bindLongPress()}
      disabled={disabled}
      onClick={() => (isSelected && !disabled) ? removeSelected(image) : addSelected(image) }>
      {isSelected && (
        <SelectedOverlay>
          <OverlayNumber>
            {selectedIndex + 1}
          </OverlayNumber>
        </SelectedOverlay>
      )}
      <GridImage src={image?.url} />
    </GridContainer>
  )
}

export { MediaGridItem }
